
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
  requireAuth?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = [],
  requireAuth = true,
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Si l'authentification n'est pas requise, affiche les enfants
  if (!requireAuth) {
    return <>{children}</>;
  }

  // Rediriger vers login si non authentifié
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Vérifier les rôles si spécifiés
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Rediriger vers le dashboard approprié avec un message d'erreur
    const redirectPath = user.role === 'supervisor' 
      ? '/supervisor/dashboard' 
      : '/secretary/dashboard';
    
    // Vous pouvez ajouter un state pour afficher un message d'erreur
    return <Navigate 
      to={redirectPath} 
      replace 
      state={{ 
        error: "Vous n'avez pas les permissions nécessaires pour accéder à cette page" 
      }} 
    />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;